import YearSelectorCard from '../../../../common/styles/YearSelectorCard'
import BookStatisticsTable from '../BookStatisticsTable'

const BookStatisticsByYearCard = () => {
	return (
		<YearSelectorCard title={'독서 요약'}>
			{(selectedYear) => <BookStatisticsTable year={selectedYear}/>}
		</YearSelectorCard>
	)
}

export default BookStatisticsByYearCard
